module.exports = __webpack_public_path__ + "media/images/athletes/1660-a1d39c5fa6d035fee90c0b34fccc9887.png";